import { render, staticRenderFns } from "./BotDeletor.vue?vue&type=template&id=2b7e6a9c&"
import script from "./BotDeletor.vue?vue&type=script&lang=js&"
export * from "./BotDeletor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports